import { Button, dialog, InfiniteScroll, Progress } from "../../../../../nq-component";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import withRouter from "../../../../../withRouter";
import Search from "../../../../../components/Search";
import BaseListPage from "../../../../../base/BaseListPage";
import { toDisplayCase } from "../../../../../nq-component";
import NavBar from "../../../../../components/navbar";
import Table from "../../../../../components/Table";
import CollapseView from "./components/CollapseView";
import InventoryPresenter from "./InventoryPresenter";
import AdjustmentTypeModal from "./components/AdjustmentTypeModal";
import RightSidebar from "../../../../../components/RightSidebar";
import Select from "react-select";
import { formatFields, formatObjects } from "./utils/helperFunc";
import PageHeader from "../../../../../components/PageHeader";

class InventoryPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new InventoryPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
    );
    this.state = {
      objects: [],
      selected: [],
      loading: true,
      total: 0,
      count: 0,
      range: "",
      showMobileFilters: false,
      categories: [],
      selectedCategory: null,
      store: [],
    };
    this.excludeFields = [
      "acl",
      "password",
      "quantity",
      "adjustedBy",
      "systemCount",
      "actualCount",
      "saleCount",
      "deductionCount",
      "storeId",
    ];
  }

  async componentDidMount() {
    super.componentDidMount();
  }

  getCollectionName() {
    return "inventory";
  }

  onClickImport() {
    this.presenter.onClickImport();
  }

  onClickExport() {
    this.presenter.onClickExport();
  }

  onChangeDate(where) {
    this.presenter.onChangeDate(where);
    this.setState({ range: where });
  }

  onCategoryChange(selectedOption) {
    this.setState({ selectedCategory: selectedOption });
    this.presenter.onCategoryChange(selectedOption);
  }

  onClickAdd() {
    const user = this.getCurrentUser();
    const store = this.state.store;
    dialog.fire({
      html: (
        <AdjustmentTypeModal
          onContinue={(selectedType) => {
            this.presenter.onClickAdd(selectedType); // optional logic
          }}
          user={user}
          store={store}
        />
      ),
      footer: false,
    });
  }

  onClickEdit(index) {
    this.presenter.onClickEdit(index);
  }

  onCollapse(index) {
    const inventory = this.state.objects[index];
    const user = this.getCurrentUser();
    return (
      <CollapseView
        inventory={inventory}
        user={user}
        onView={() => this.onClickEdit(index)}
      />
    );
  }

  closeDialog() {
    dialog.close();
  }
  setStore(store) {
    this.setState({ store });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, selected, count, loading, categories, selectedCategory } =
      this.state;
    const user = this.getCurrentUser();
    const isAdmin = user?.roles?.some((r) => r.id === "Admin");

    const baseExcludeFields = [
      "acl",
      "password",
      "quantity",
      "adjustedBy",
      "systemCount",
      "actualCount",
      "saleCount",
      "deductionCount",
      "deductionCountPrevious",
    ];

    const excludeFields = isAdmin
      ? baseExcludeFields
      : [...baseExcludeFields, "storeId"];

    if (!schema) return <Progress />;
    return (
      <>
        <NavBar
        // action={() => {
        //   return (
        //     <div className="dropdown dropstart d-inline-block">
        //       <i
        //         role="button"
        //         data-bs-toggle="dropdown"
        //         className="bi bi-three-dots-vertical"
        //       ></i>
        //       <div className="dropdown-menu fs-xs ">
        //         <button
        //           onClick={this.onClickExport.bind(this)}
        //           className="dropdown-item py-3"
        //           style={{ backgroundColor: "#82c14a", color: "white" }}
        //         >
        //           <i className="fas fa-file-csv me-2"></i>
        //           Export Data
        //         </button>
        //       </div>
        //     </div>
        //   );
        // }}
        />
        <RightSidebar
          isVisible={this.state.showMobileFilters}
          onClose={() => this.setState({ showMobileFilters: false })}
          onDateChange={this.onChangeDate.bind(this)}
          range={this.state.range}
        />
        <div className="overflow-auto">
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            hasMore={!loading && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div className="d-flex justify-content-between align-items-center">
                <PageHeader
                  title={
                    schema.label || toDisplayCase(this.getCollectionName())
                  }
                  subtitle={schema.description}
                  icon="bi bi-box-seam"
                />

                <div className="d-flex align-items-center gap-1 text-muted small">
                  <span className="fw-medium">
                    {selected.length > 0 ? "Selected" : "Total"}
                  </span>

                  <span className="fw-bold text-dark">
                    {selected.length > 0 ? selected.length : objects.length}
                  </span>

                  <span> / {count}</span>
                </div>
              </div>

              <div className="p-3 p-lg-3 bg-white border rounded-4 shadow-sm">
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <div className="d-flex align-items-center gap-2">
                    <i className="bi bi-funnel text-primary" />
                    <span className="fw-semibold">Filters</span>
                    <span className="text-muted small">
                      Refine your inventory list
                    </span>
                  </div>
                </div>

                <div className="row g-3 align-items-end">
                  <div className="col-lg-7 col-12">
                    <label className="form-label small text-muted mb-1">
                      Search
                    </label>
                    <div className="position-relative">
                      <div style={{ paddingLeft: 2 }}>
                        <Search
                          schemas={this.getSchemas()}
                          onSubmit={this.searchSubmit.bind(this)}
                          fields={schema.fields}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-5 col-12">
                    <label className="form-label small text-muted mb-1">
                      Category
                    </label>
                    <Select
                      value={selectedCategory}
                      onChange={this.onCategoryChange.bind(this)}
                      options={categories}
                      isClearable
                      placeholder="All categories"
                      className="react-select-container"
                      classNamePrefix="react-select"
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          minHeight: "44px",
                          borderRadius: "14px",
                          borderColor: state.isFocused
                            ? "#86b7fe"
                            : base.borderColor,
                          boxShadow: state.isFocused
                            ? "0 0 0 .2rem rgba(13,110,253,.15)"
                            : "none",
                        }),
                        valueContainer: (base) => ({
                          ...base,
                          paddingLeft: 12,
                        }),
                        placeholder: (base) => ({ ...base, color: "#6c757d" }),
                      }}
                    />
                  </div>
                </div>
              </div>

              <Table
                fields={formatFields(schema.fields, user)}
                objects={formatObjects(objects, user)}
                selectable
                collapsable
                excludeFields={Object.keys(schema.fields).reduce((acc, key) => {
                  const options = schema.fields[key];
                  if (options.read === false) {
                    acc.push(key);
                  }
                  switch (options._type || options.type) {
                    case "Relation":
                    case "Array":
                    case "Object":
                    case "File":
                      acc.push(key);
                      break;
                    default:
                  }
                  return acc;
                }, excludeFields)}
                selected={selected}
                onSelect={this.onSelect.bind(this)}
                onSelectAll={this.onSelectAll.bind(this)}
                onCollapse={this.onCollapse.bind(this)}
                progress={loading}
                onClickItem={this.onClickItem.bind(this)}
                className="mt-3"
              />
            </div>
          </InfiniteScroll>
        </div>
        <div className="position-fixed bottom-0 end-0 m-4">
          <Button
            className="btn shadow-sm"
            onClick={this.onClickAdd.bind(this)}
            style={{
              width: "50px",
              height: "50px",
              borderRadius: "25px",
              backgroundColor: "#82c14a",
              color: "white",
            }}
          >
            <i className="bi bi-plus-lg" />
          </Button>
        </div>
      </>
    );
  }
}

export default withRouter(InventoryPage);
